var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{staticClass:"mr-4",attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"#6A6E7B","outlined":""},on:{"click":function($event){return _vm.onClick($event)}}},'v-btn',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_c('span',[_vm._t("tooltip")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }